import { type ActionIntent } from "../QueryEvaluator/ActionIntent";
import {
	type QueryEvaluatorState,
	errorQueryEvaluatorState,
} from "../QueryEvaluator/QueryManagerState";

export interface QueryPersistence {
	localStateReplica(): QueryEvaluatorState;
	ensurePersistedState(actionIntent: ActionIntent): Promise<void>;
}

export const errorQueryPersistence = (error: Error): QueryPersistence => ({
	localStateReplica: () => errorQueryEvaluatorState(error),
	ensurePersistedState: () => {
		throw error;
	},
});
